<template>
  <v-container>
    <div class="table-wrapper">
    <h2>Weekly Report</h2>
    <v-data-table
      :headers="headers"
      :items="items"
      hide-default-footer
      class="custom-table"
    >
      <!-- Total Appointments input field -->
      <template v-slot:[`item.totalAppointments`]="{ item }">
        <v-text-field
          v-model="item.totalAppointments"
          outlined
          type="number"
          class="number-input"
        ></v-text-field>
      </template>
      <!-- Total Presentations input field -->
      <template v-slot:[`item.totalPresentations`]="{ item }">
        <v-text-field
          v-model="item.totalPresentations"
          outlined
          type="number"
          class="number-input"
        ></v-text-field>
      </template>
      <!-- Sales input field -->
      <template v-slot:[`item.sales`]="{ item }">
        <v-text-field
          v-model="item.sales"
          outlined
          type="number"
          class="number-input"
        ></v-text-field>
      </template>
      <!-- Price Breakdown (North) input field -->
      <template v-slot:[`item.priceBreakdownNorth`]="{ item }">
        <v-text-field
          v-model="item.priceBreakdownNorth"
          outlined
          type="number"
          class="number-input"
        ></v-text-field>
      </template>
      <!-- Price Breakdown (South) input field -->
      <template v-slot:[`item.priceBreakdownSouth`]="{ item }">
        <v-text-field
          v-model="item.priceBreakdownSouth"
          outlined
          type="number"
          class="number-input"
        ></v-text-field>
      </template>
      <!-- Price Breakdown (East) input field -->
      <template v-slot:[`item.priceBreakdownEast`]="{ item }">
        <v-text-field
          v-model="item.priceBreakdownEast"
          outlined
          type="number"
          class="number-input"
        ></v-text-field>
      </template>
      <!-- Price Breakdown (West) input field -->
      <template v-slot:[`item.priceBreakdownWest`]="{ item }">
        <v-text-field
          v-model="item.priceBreakdownWest"
          outlined
          type="number"
          class="number-input"
        ></v-text-field>
      </template>
      <!-- Price input field -->
      <template v-slot:[`item.price`]="{ item }">
        <v-text-field
          v-model="item.price"
          outlined
          type="number"
          class="number-input"
        ></v-text-field>
      </template>
    </v-data-table>
  </div>

     <div class="table-wrapper">
      <h2>Sales Details</h2>
      <v-data-table
        :headers="salesHeaders"
        :items="salesItems"
        hide-default-footer
        class="custom-table"
      >
        <!-- Custom input slots for each data field -->
        <template v-slot:[`item.clientName`]="{ item }">
          <v-text-field v-model="item.clientName" outlined></v-text-field>
        </template>
        <template v-slot:[`item.localReward`]="{ item }">
          <v-text-field v-model="item.localReward" outlined></v-text-field>
        </template>
        <template v-slot:[`item.newCategory`]="{ item }">
          <v-text-field v-model="item.newCategory" outlined></v-text-field>
        </template>
        <template v-slot:[`item.methodOfPayment`]="{ item }">
          <v-text-field v-model="item.methodOfPayment" outlined></v-text-field>
        </template>
        <template v-slot:[`item.renewal`]="{ item }">
          <v-text-field v-model="item.renewal" outlined></v-text-field>
        </template>
        <template v-slot:[`item.bookingRegion`]="{ item }">
          <v-text-field v-model="item.bookingRegion" outlined></v-text-field>
        </template>
        <template v-slot:[`item.size`]="{ item }">
          <v-text-field v-model="item.size" outlined></v-text-field>
        </template>
        <template v-slot:[`item.price`]="{ item }">
          <v-text-field v-model="item.price" outlined type="number"></v-text-field>
        </template>
      </v-data-table>
      <v-btn @click="addNewRow">Add New Row</v-btn>
    </div>

    <div class="table-wrapper">
      <h2>Failed Apps</h2>
      <v-data-table
        :headers="additionalHeaders"
        :items="additionalItems"
        hide-default-footer
        class="custom-table"
      >
        <!-- Custom input slots for each data field -->
        <template v-slot:[`item.businessName`]="{ item }">
          <v-text-field v-model="item.businessName" outlined></v-text-field>
        </template>
        <template v-slot:[`item.appointmentType`]="{ item }">
          <v-select v-model="item.appointmentType" :items="['Telemarketing', 'Personal']" outlined></v-select>
        </template>
        <template v-slot:[`item.reasonsDidntBuy`]="{ item }">
          <v-text-field v-model="item.reasonsDidntBuy" outlined></v-text-field>
        </template>
        <template v-slot:[`item.phoneNumber`]="{ item }">
          <v-text-field v-model="item.phoneNumber" outlined></v-text-field>
        </template>
      </v-data-table>
      <v-btn @click="addNewAdditionalRow">Add New Additional Row</v-btn>
    </div>

    <div class="table-wrapper">
      <h2>Missed Appointments</h2>
      <v-data-table
        :headers="missedAppointmentHeaders"
        :items="missedAppointmentItems"
        hide-default-footer
        class="custom-table"
      >
        <!-- Custom input slots for each data field -->
        <template v-slot:[`item.businessName`]="{ item }">
          <v-text-field v-model="item.businessName" outlined></v-text-field>
        </template>
        <template v-slot:[`item.appointmentType`]="{ item }">
          <v-select v-model="item.appointmentType" :items="['Telemarketing', 'Personal']" outlined></v-select>
        </template>
        <template v-slot:[`item.actionToReschedule`]="{ item }">
          <v-text-field v-model="item.actionToReschedule" outlined></v-text-field>
        </template>
        <template v-slot:[`item.rate`]="{ item }">
          <v-text-field v-model="item.rate" outlined type="number" min="1" max="10"></v-text-field>
        </template>
      </v-data-table>
      <v-btn @click="addNewMissedAppointmentRow">Add New Missed Appointment Row</v-btn>
    </div>

      <div class="table-wrapper">
      <h2>Personal Phone Calls & Apps</h2>
    <!-- Display multiple custom checkboxes in a row -->
      <div v-for="(day, index) in days" :key="index">
      <h3>{{ day }}</h3> <!-- Label for the day -->
      <div class="custom-checkbox-row">
        <custom-checkbox v-for="(value, i) in checkboxValues[index]" :key="i" v-model="checkboxValues[index][i]"></custom-checkbox>
      </div>
       <v-btn
      class="mx-2"
      fab
      dark
      color="indigo"
      small
      @click="addMoreCheckboxes(index)"
    >
      <v-icon dark>
        mdi-plus
      </v-icon>
    </v-btn> <!-- Button to add more checkboxes to this row -->
    </div></div>


    <v-btn @click="generatePDF">Generate PDF</v-btn>
  </v-container>
</template>

<script>
    import jsPDF from 'jspdf';
    import CustomCheckbox from './CustomCheckbox.vue';
    import 'jspdf-autotable';
export default {
  components: {
    CustomCheckbox
  },
  data() {
    return {
      headers: [
        { text: 'Days', align: 'left', sortable: false, value: 'label' },
        { text: 'Total Appointments', align: 'left', sortable: false, value: 'totalAppointments' },
        { text: 'Total Presentations', align: 'left', sortable: false, value: 'totalPresentations' },
        { text: 'Sales', align: 'left', sortable: false, value: 'sales' },
        { text: 'Price Breakdown (North)', align: 'left', sortable: false, value: 'priceBreakdownNorth' },
        { text: 'Price Breakdown (South)', align: 'left', sortable: false, value: 'priceBreakdownSouth' },
        { text: 'Price Breakdown (East)', align: 'left', sortable: false, value: 'priceBreakdownEast' },
        { text: 'Price Breakdown (West)', align: 'left', sortable: false, value: 'priceBreakdownWest' },
        { text: 'Price', align: 'left', sortable: false, value: 'price' },
      ],
      items: [
        { label: 'Monday', totalAppointments: '', totalPresentations: '', sales: '', priceBreakdownNorth: '', priceBreakdownSouth: '', priceBreakdownEast: '', priceBreakdownWest: '', price: '' },
        { label: 'Tuesday', totalAppointments: '', totalPresentations: '', sales: '', priceBreakdownNorth: '', priceBreakdownSouth: '', priceBreakdownEast: '', priceBreakdownWest: '', price: '' },
        { label: 'Wednesday', totalAppointments: '', totalPresentations: '', sales: '', priceBreakdownNorth: '', priceBreakdownSouth: '', priceBreakdownEast: '', priceBreakdownWest: '', price: '' },
        { label: 'Thrusday', totalAppointments: '', totalPresentations: '', sales: '', priceBreakdownNorth: '', priceBreakdownSouth: '', priceBreakdownEast: '', priceBreakdownWest: '', price: '' },
        { label: 'Friday', totalAppointments: '', totalPresentations: '', sales: '', priceBreakdownNorth: '', priceBreakdownSouth: '', priceBreakdownEast: '', priceBreakdownWest: '', price: '' },
      ],
       salesHeaders: [
        { text: 'Client Name', align: 'left', sortable: false, value: 'clientName' },
        { text: 'Local Reward', align: 'left', sortable: false, value: 'localReward' },
        { text: 'New Category', align: 'left', sortable: false, value: 'newCategory' },
        { text: 'Method of Payment', align: 'left', sortable: false, value: 'methodOfPayment' },
        { text: 'Renewal', align: 'left', sortable: false, value: 'renewal' },
        { text: 'Booking Region', align: 'left', sortable: false, value: 'bookingRegion' },
        { text: 'Size', align: 'left', sortable: false, value: 'size' },
        { text: 'Price (not inc. GST)', align: 'left', sortable: false, value: 'price' },
      ],
      salesItems: [
        // Initial row
        { clientName: '', localReward: '', newCategory: '', methodOfPayment: '', renewal: '', bookingRegion: '', size: '', price: '' },
      ],
       additionalHeaders: [
        { text: 'Business Name', align: 'left', sortable: false, value: 'businessName' },
        { text: 'Appointment Type', align: 'left', sortable: false, value: 'appointmentType' },
        { text: 'Reasons They Didn\'t Buy', align: 'left', sortable: false, value: 'reasonsDidntBuy' },
        { text: 'Phone Number', align: 'left', sortable: false, value: 'phoneNumber' },
      ],
      additionalItems: [{ 
        businessName: '',
        appointmentType: '',
        reasonsDidntBuy: '',
        phoneNumber: ''
      }],
       missedAppointmentHeaders: [
        { text: 'Missed Appointment (Business Name)', align: 'left', sortable: false, value: 'businessName' },
        { text: 'Appointment Type', align: 'left', sortable: false, value: 'appointmentType' },
        { text: 'Action Taken to Reschedule', align: 'left', sortable: false, value: 'actionToReschedule' },
        { text: 'Rate (1-10)', align: 'left', sortable: false, value: 'rate' },
      ],
      missedAppointmentItems: [{ 
        businessName: '',
        appointmentType: '',
        actionToReschedule: '',
        rate: ''
      }],
      days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      checkboxValues: Array.from({ length: 5 }, () => Array.from({ length: 30 }, () => '')) 
    };
  },
  methods: {
    generatePDF() {
  const doc = new jsPDF();
  let yOffset = 10;

  // Function to add new page if needed
  function addNewPageIfNeeded() {
    if (yOffset >= 290) {
      doc.addPage();
      yOffset = 10;
    }
  }

  // Add data from the Weekly Report table
  addNewPageIfNeeded();
  doc.text(6, yOffset, 'Weekly Report');
  yOffset += 10;
  doc.autoTable({
    head: [this.headers.map(header => header.text)],
    body: this.items.map(item => this.headers.map(header => item[header.value])),
    startY: yOffset,
    theme: 'plain',
    // styles: { halign: 'center' }
  });
  yOffset += this.items.length * 10 + 20;

  const checkboxData = [];

// Loop through the checkboxValues array to extract values for each day
for (let i = 0; i < this.checkboxValues.length; i++) {
  const dayCheckboxValues = this.checkboxValues[i];
  
  // Convert checkbox values to a string and push to the checkboxData array
  checkboxData.push(dayCheckboxValues.join(' '));
}
// Add data from the Custom Checkboxes table
addNewPageIfNeeded();
doc.text(6, yOffset, 'Personal Phone Calls & Apps');
yOffset += 10;

doc.autoTable({
  head: [['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday']],
  body: [checkboxData],
  startY: yOffset,
  theme: 'plain',
  styles: { cellPadding: 2 }
});
yOffset += 30; // Adjust height for the table

  doc.addPage();
  // Add data from the Failed Apps table
  addNewPageIfNeeded();
  yOffset = 10;
  doc.text(6, yOffset, 'Failed Apps');
  yOffset += 10;
  doc.autoTable({
    head: [this.additionalHeaders.map(header => header.text)],
    body: this.additionalItems.map(item => this.additionalHeaders.map(header => item[header.value])),
    startY: yOffset,
    theme: 'plain',
    styles: { halign: 'center' }
  });
  yOffset += this.additionalItems.length * 10 + 20;

  doc.addPage();
  // Add data from the Missed Appointments table
  addNewPageIfNeeded();
  yOffset = 10;
  
  doc.text(6, yOffset, 'Missed Appointments');
  yOffset += 10;
  doc.autoTable({
    head: [this.missedAppointmentHeaders.map(header => header.text)],
    body: this.missedAppointmentItems.map(item => this.missedAppointmentHeaders.map(header => item[header.value])),
    startY: yOffset,
    theme: 'plain',
    styles: { halign: 'center' }
  });
  yOffset += this.missedAppointmentItems.length * 10 + 20;

    // Add a new page before rendering Sales Details
    doc.addPage();
    yOffset = 10;
    // Add data from the Sales Details table
    addNewPageIfNeeded();
    doc.text(6, yOffset, 'Sales Details');
    yOffset += 10;
    doc.autoTable({
      head: [this.salesHeaders.map(header => header.text)],
      body: this.salesItems.map(item => this.salesHeaders.map(header => item[header.value])),
      startY: yOffset,
      theme: 'plain',
      styles: { halign: 'center' }
    });
    yOffset += this.salesItems.length * 10 + 20;
  // Add an empty array to store checkbox values


  const pdfBlob = doc.output('blob');

  // Generate URL for Blob
  const pdfUrl = URL.createObjectURL(pdfBlob);

  // Open PDF in new tab
  window.open(pdfUrl, '_blank');

  // Clean up
  URL.revokeObjectURL(pdfUrl);


}

,
    addNewRow() {
      // Add a new row to the sales table
      this.salesItems.push({ clientName: '', localReward: '', newCategory: '', methodOfPayment: '', renewal: '', bookingRegion: '', size: '', price: '' });
    },
     addNewAdditionalRow() {
      // Add a new row to the additional details table
      this.additionalItems.push({ 
        businessName: '',
        appointmentType: '',
        reasonsDidntBuy: '',
        phoneNumber: ''
      });
    },
    addNewMissedAppointmentRow() {
      // Add a new row to the missed appointments table
      this.missedAppointmentItems.push({ 
        businessName: '',
        appointmentType: '',
        actionToReschedule: '',
        rate: ''
      });
    },
     handleChange() {
      // Ensure the input is either "x" or "-"
      if (this.checkedValue !== 'x' && this.checkedValue !== '*' && this.checkedValue !== '/') {
        this.checkedValue = ''; // Reset to empty if input is invalid
      }
    },
      addMoreCheckboxes(rowIndex) {
      // Add 10 more empty values to the checkboxValues array
      for (let i = 0; i < 10; i++) {
        this.checkboxValues[rowIndex].push('');
      }
    }
  },
};
</script>

<style>
.custom-checkbox-row {
  display: flex;
  flex-wrap: wrap;
}

.custom-checkbox-row .custom-checkbox:last-child {
  margin-right: 0; /* Remove margin for the last checkbox in the row */
}

.add-button {
  border-radius: 50%; /* Make button perfectly round */
  font-size: 20px; /* Adjust font size */
  width: 30px; /* Increase button width */
  height: 50px; /* Increase button height */
  padding: 0; /* Remove padding */
}
.table-wrapper {
  margin-bottom: 20px; /* Add margin below each table */
}

.custom-table {
  border: 1px solid #000; /* Add border */
}

.checkbox-row {
  display: flex; /* Use flexbox for row alignment */
}

.checkbox-col {
  width: 10%; /* Adjust width of each column containing checkboxes */
}

.add-row-button-col {
  width: 10%; /* Adjust width of the column containing the 'Add Row' button */
}
.custom-table {
  width: 100%;
}

.text-input {
  width: 200px; /* Adjust width for text-based input fields */
}


</style>
